import { Component, h, Prop, Host } from '@stencil/core';
import { ComponentView } from '../../../../types/types';
import { ButtonAppearance, ButtonSize } from '../../../atoms/rentware-button/types';
import { t } from '../../../../redux/utils';
import { PickerDate } from '../../../rtr-article-details/utils/types';

@Component({
  tag: 'rtr-cart-reservation-summary',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareCartControlButton {
  @Prop() pickerDate!: PickerDate;
  @Prop() onOpenCheckout!: () => void;

  get buttonAppearance(): ButtonAppearance {
    return {
      fullWidth: true,
      size: ButtonSize.XL,
    };
  }

  get buttonText() {
    return t('cart.checkoutNow');
  }

  render() {
    return (
      <Host class="CRSummaryContainer">
        <rentware-cart-expandable cartView={ComponentView.Details} pickerDate={this.pickerDate} />

        <rentware-spacer size="M" />

        <div class="CRButtonContainer">
          <rentware-button appearance={this.buttonAppearance} buttonText={this.buttonText} onClick={this.onOpenCheckout} />
        </div>
      </Host>
    );
  }
}
